import {
  INVALIDATE_COMPTE_PAIEMENT,
  INVALIDATE_DEPENSES,
  INVALIDATE_DETTES,
  INVALIDATE_ECRITURE,
  INVALIDATE_FISCALITE,
  INVALIDATE_LIVRE_JOURNAL,
  INVALIDATE_TRANSACTIONS,
} from 'actions/invalidationTags';
import { ApiMananger } from 'actions/rtkquery';
import {
  ADD_OBLIGATION_FISCALE_API_ROUTE,
  DECLARER_OBLIGATION_FISCALE_API_ROUTE,
  DELETE_OBLIGATION_FISCALE_API_ROUTE,
  PARAMETRES_FISCAUX_API_ROUTE,
  PAYER_OBLIGATION_FISCALE_API_ROUTE,
  SEED_OBLIGATIONS_FISCALES_API_ROUTE,
  UPDATE_OBLIGATION_FISCALE_API_ROUTE,
} from 'routes/api/endpoints';

// Un paiement fiscal touche la trésorerie ET la comptabilité :
// on invalide donc les caches dépenses/transactions/écritures en plus du module.
const TAGS_PAIEMENT = [
  INVALIDATE_FISCALITE,
  INVALIDATE_DEPENSES,
  INVALIDATE_TRANSACTIONS,
  INVALIDATE_COMPTE_PAIEMENT,
  INVALIDATE_ECRITURE,
  INVALIDATE_LIVRE_JOURNAL,
  INVALIDATE_DETTES,
];

const fiscaliteApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    addObligationFiscale: build.mutation({
      query: (data) => ({
        url: ADD_OBLIGATION_FISCALE_API_ROUTE,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [INVALIDATE_FISCALITE],
    }),
    updateObligationFiscale: build.mutation({
      query: ({ id, ...data }) => ({
        url: `${UPDATE_OBLIGATION_FISCALE_API_ROUTE}${id}/`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: [INVALIDATE_FISCALITE],
    }),
    deleteObligationFiscale: build.mutation({
      query: (id) => ({
        url: `${DELETE_OBLIGATION_FISCALE_API_ROUTE}${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [INVALIDATE_FISCALITE],
    }),
    payerObligationFiscale: build.mutation({
      query: ({ id, ...data }) => ({
        url: `${PAYER_OBLIGATION_FISCALE_API_ROUTE}${id}/payer/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: TAGS_PAIEMENT,
    }),
    declarerObligationFiscale: build.mutation({
      query: ({ id, ...data }) => ({
        url: `${DECLARER_OBLIGATION_FISCALE_API_ROUTE}${id}/declarer/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [INVALIDATE_FISCALITE],
    }),
    seedObligationsFiscales: build.mutation({
      query: (data) => ({
        url: SEED_OBLIGATIONS_FISCALES_API_ROUTE,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [INVALIDATE_FISCALITE],
    }),
    updateParametresFiscaux: build.mutation({
      query: (data) => ({
        url: PARAMETRES_FISCAUX_API_ROUTE,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: [INVALIDATE_FISCALITE],
    }),
  }),
});

export const {
  useAddObligationFiscaleMutation,
  useUpdateObligationFiscaleMutation,
  useDeleteObligationFiscaleMutation,
  usePayerObligationFiscaleMutation,
  useDeclarerObligationFiscaleMutation,
  useSeedObligationsFiscalesMutation,
  useUpdateParametresFiscauxMutation,
} = fiscaliteApi;
